//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api"; // ⭐ เพิ่ม — ยังไม่มีใน edit เดิม ใช้เรียก timeline endpoints
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { server } from "@/services/constants";
import {
  getIncorporateDocketById,
  updateIncorporateDocket,
  // ⭐ เพิ่มใหม่ — บันทึก Change Tracker ทั้งชุด
  replaceIncorporateDocketChangeAll,
  // ⭐ เพิ่มใหม่ — ลบไฟล์แนบ 1 ไฟล์ออกจาก docket (ดู api_incorporate.js
  // ต้องเพิ่ม wrapper นี้ก่อน — เรียก DELETE /incorporate-docket/:id/attachment)
  removeIncorporateDocketAttachment,
  getIncorporateMatterById,
} from "@/services/api-dtime/api_incorporate";
// ⭐ เพิ่มใหม่ — CRUD ของ Document Category (ตารางลูก incorporate_docket_doc_category
// ไม่มี replace-all endpoint เหมือน change_tracker ต้อง diff เองตอน save)
import {
  getIncorporateDocketDocCategoryByDocketId,
  createIncorporateDocketDocCategory,
  deleteIncorporateDocketDocCategory,
} from "@/services/api-dtime/api_incorporate_docket_doc_category";
import TimeLineOperations from "../timeline/TimeLineOperations.vue"; // ⭐ เพิ่ม
import InvoiceSectionPanel from "../payment-invoice/InvoiceSectionPanel.vue";
import PDFCaseProgress from "@/utils/pdfClientTimeLine"; // ⭐ เพิ่ม
const moment = require("moment-timezone"); // ⭐ เพิ่ม

// ✅ ไฟล์ incorporate ถูกเก็บที่ Production Storage (เหมือน Matter)
// path จริงคือ {PRODUCTION_STORAGE_URL}/incorporatedocket/{docketId}/{filename}
// ตาม static route ที่ตั้งไว้ใน production storage app.js:
//   app.use("/incorporatedocket", express.static(...))
const INCORPORATE_DOCKET_FILE_URL = process.env.VUE_APP_PRODUCTION_STORAGE_URL
  ? `${process.env.VUE_APP_PRODUCTION_STORAGE_URL}/incorporatedocket`
  : "http://localhost:3001/incorporatedocket";

export default {
  name: "incorporate-docket-edit",
  components: { SuccessDialog, SuccessDialogPush, TimeLineOperations, InvoiceSectionPanel }, // ⭐ เพิ่ม TimeLineOperations
  data() {
    return {
      shareholdersNumber: 0,
      shareholdersMaxNumber: 0,
      existingShareholdersCount: 0,
      syncedShareholdersAmount: 0,
      directorsListShow: [],
      docketId: null,
      pageLoading: true,
      matterId: null,
      loadingSave: false,

      fileIncorporateUrl: INCORPORATE_DOCKET_FILE_URL,

      // ⭐ ไฟล์ที่มีอยู่แล้วบน server (จาก docket.file_attachments) — แสดงเป็น
      // รายการ read-only พร้อมปุ่ม preview/download/ลบ แยกออกจาก form.attachments
      // ซึ่งเป็น File object ใหม่ที่ยังไม่อัปโหลด (v-file-input สร้าง File object
      // จาก URL ที่มีอยู่แล้วไม่ได้ — เป็นข้อจำกัดของ browser ไม่ใช่บั๊ก จึงต้อง
      // แยก 2 state นี้ออกจากกันเสมอ)
      existingAttachments: [],
      removingFile: null,
      dialogConfirmDelete: false,
      fileToDelete: null,

      rules: {
        required: (v) =>
          (v !== null && v !== undefined && String(v).trim() !== "") ||
          "กรุณากรอกข้อมูล",
      },

      form: {
        matter_id: null,
        client_name: "",
        entity_type: "",
        registration_no: "",
        inquiry_topic: "",
        date_received: "",
        date_submitted: "",
        next_due_date: "",
        doc_category: [], // ⭐ เปลี่ยนจาก "" เป็น [] (multi-select เหมือน add.vue)
        attachments: [], // ไฟล์ใหม่ที่ยังไม่อัปโหลด (File objects)
        change_tracker: [],
        remark: "",
        status: "In Progress",
      },

      // ⭐ เพิ่มใหม่ — เก็บ Document Category ที่มีอยู่แล้วใน DB พร้อม id
      // ของแถว (จาก incorporate_docket_doc_category) ใช้เทียบตอน
      // updateDocket() ว่าอันไหนต้อง create ใหม่ อันไหนต้อง delete ออก
      // เพราะไม่มี replace-all endpoint ให้ใช้เหมือน change_tracker
      existingDocCategories: [], // [{ id, doc_category }, ...]

      // ✅ UI state เท่านั้น — ยังไม่มี table รองรับฝั่ง backend
      trackerDetail: {
        shareholders: [
          {
            full_name: "",
            nationality: "",
            ordinary_shares: 0,
            preferred_shares: 0,
          },
        ],
        directors: [{ full_name: "", nationality: "", authorized: "No" }],
        reg_capital: "",
        paidup_capital: "",
        company_name: "",
        reg_address: "",
        audit_firm: "",
        auditor_name: "",
        auditor_license_no: "",
        accountant_firm: "",
        accountant_name: "",
        others_detail: "",
      },
      // ✅ UI state: { [trackerKey]: ['agency1', 'agency2'] }
      selectedAgencies: {},

      docCategoryOptions: [
        "Company Incorporation Documents | เอกสารตั้งบริษัท",
        "Certified Copy + Registration Items + Application",
        "Memorandum of Association | บช.บริคณห์สนธิ",
        "Articles of Association | ข้อบังคับ",
        "List of Shareholders (Form BorJor.5) | บัญชีรายชื่อผู้ถือหุ้น",
        "Financial Statement Submission Forms (SorBorChor.3)",
        "Tax Information | ข้อมูลภาษี",
        "Share Certificates / Share Register | ใบหุ้น/ทะเบียนหุ้น",
        "Minutes of Board of Directors' Meeting",
        "Minutes of Extraordinary Shareholders' Meeting",
        "Minutes of Annual General Shareholders' Meeting",
        "BOI Documents / Promotion Certificate",
        "Various Licenses / Permits | ใบอนุญาตต่าง ๆ",
        "Agreements / Contracts | สัญญาต่าง ๆ",
        "Legal Opinion | ความเห็นทางกฎหมาย",
        "Work Rules | ข้อบังคับการทำงาน",
        "Due Diligence Report",
        "Others | อื่น ๆ",
      ],

      trackerOptions: [
        { key: "shareholders", label: "👥 Shareholders | ผู้ถือหุ้น" },
        { key: "directors", label: "👔 Directors | กรรมการบริษัท" },
        { key: "reg-capital", label: "💰 Registered Capital (THB)" },
        { key: "paidup-capital", label: "💵 Paid-up Capital (THB)" },
        { key: "company-name", label: "🏢 Company Name | ชื่อบริษัท" },
        { key: "reg-address", label: "📍 Registered Address (Head Office)" },
        { key: "auditor", label: "📋 Auditor | ผู้สอบบัญชี" },
        { key: "accountant", label: "📊 Accountant | ผู้ทำบัญชี" },
        { key: "others", label: "📝 Others | อื่น ๆ" },
      ],

      agencyOptions: [
        "กรมพัฒนาธุรกิจการค้า (DBD)",
        "คปภ. (OIC)",
        "ประกันสังคม (SSO)",
        "สรรพากร (Revenue)",
        "การนิคมอุตสาหกรรม (IEAT)",
        "สถานฑูต (Embassy)",
        "กรมการกงสุล (Consular)",
        "สำนักงานเขต / เทศบาล / อบต.",
        "BOI",
        "กรมศุลกากร (Customs)",
        "อื่น ๆ (Others)",
      ],

      // ⚠️ เดิมของ Edit — ไม่ได้ลบ เผื่อจุดอื่นในระบบยังอ้างอิงอยู่
      // แต่ v-select ของ Status ไม่ได้ผูกกับตัวนี้แล้ว (เปลี่ยนไปใช้ statuslist
      // ที่โหลดจาก client_timeline_status_config แทน เพื่อให้ map ไป
      // timeline_status_id ได้ตามที่ระบบ Timeline ต้องการ)
      statusOptions: [
        { label: "In Progress | กำลังดำเนินการ", value: "In Progress" },
        { label: "Complete | เสร็จสิ้น", value: "Complete" },
        {
          label: "Request Payment | ขอเรียกเก็บเงิน",
          value: "Request Payment",
        },
        { label: "Cancelled | ยกเลิก", value: "Cancelled" },
      ],

      dialogAdd: false,
      dialogAddPush: false,
      text_color: "text-h5 green--text text-center",
      title: "",
      message: "",
      link: "",

      // ⭐ เพิ่มใหม่ทั้งหมด — สำหรับ Internal Timeline tab (ตามแบบ
      // incorporate-docket-add.vue) modeOperations ส่งเป็น "Edit" เพื่อให้
      // TimeLineOperations.vue โหลดประวัติ timeline เดิมที่เคยมีมาแสดงด้วย
      tabselect: 0,
      timelineStatus: 0,
      status_note: "",
      visible_check: false,
      dialogDelete: false,
      timeline_case_id: 0,
      module_name: "Corporate",
      modeOperations: "Edit",
      reportlist: [],
      statuslist: [],
      //quotations
      formQutations: {
        salesOrderId: 0,
        price: 0,
        customerName: "",
        currency: "",
        invoiceId: "",          // 👈 เพิ่ม
      },
      salesOrderList: [],
      invoiceList: [],
      invoiceSelectList: [],
      // invoiceMenu: false,
      // invoiceMenuPay: false,
      invoiceStatusList: ["Draft", "Requested", "Invoiced", "Paid"],
      quotationscheckstatus: '',
      client_id: 0,
      client_name_show: "",
      matterdatalist: [],
      initialTrackerShareholdersCount: 0,
    };
  },
  computed: {
    entityTypeLabel() {
      const map = {
        "Limited Company": "Limited Company | บริษัทจำกัด",
        "Public Company Limited": "Public Company Limited | บริษัทมหาชนจำกัด",
        Foundation: "Foundation | มูลนิธิ",
        "Representative Office": "Representative Office | สำนักงานผู้แทนการค้า",
        Individual: "Individual | บุคคลธรรมดา",
      };
      return map[this.form.entity_type] || this.form.entity_type || "-";
    },
    requestPaymentDisabled() {
      const price = Number(this.formQutations.price);
      const salesOrderId = Number(this.formQutations.salesOrderId);
      const matterId = Number(this.form.matter_id);

      const isPriceValid = !isNaN(price) && price > 0;
      const isSalesOrderIdValid = !isNaN(salesOrderId) && salesOrderId > 0;
      const isMatterIdValid = !isNaN(matterId) && matterId > 0;

      return !(isPriceValid && isSalesOrderIdValid && isMatterIdValid);
    },
    // ⭐ เพิ่มใหม่ — รายการ Document Category ที่โหลดมาแล้วไม่ตรงกับ
    // docCategoryOptions ปัจจุบันสักตัว (เผื่อ options ถูกแก้ข้อความทีหลัง)
    unmatchedDocCategories() {
      return this.form.doc_category.filter(
        (cat) => !this.docCategoryOptions.includes(cat)
      );
    },
    shareholdersCurrentDisplay() {
      return Math.max(0, this.shareholdersNumber - this.syncedShareholdersAmount);
    },
    // ⭐ เพิ่มใหม่ — เหมือนหน้า Add
    shareholdersAddedFromTracker() {
      return this.trackerDetail.shareholders.reduce(
        (sum, sh) => sum + (Number(sh.ordinary_shares) || 0),
        0
      );
    },
    directorsPreviewFiltered() {
      const trackedIds = this.trackerDetail.directors
        .map((d) => d.matter_director_id)
        .filter((id) => id !== null && id !== undefined);

      return this.directorsListShow.filter(
        (dir) => !trackedIds.includes(dir.id)
      );
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    await this.loadDataInvoice(this.$route.params.id);
    await this.loadDataInvoiceSelect(this.$route.params.id);
    await this.loaddataSalesOrder();
    await this.loadMatterList();
    this.$hideLoader();
    this.docketId = this.$route.params.id;

    // ⭐ เพิ่ม — TimeLineOperations ใช้ timeline_case_id ตัวนี้ query ประวัติ
    // (ต้องผูกกับ id เดียวกับ docketId ของ incorporate docket เสมอ)
    this.timeline_case_id = Number(this.docketId);

    // ⭐ เพิ่ม — โหลด statuslist (client_timeline_status_config) ก่อน
    // loadDocket() เพื่อให้ sendToStatus() หา module_id ของ docket.status
    // ที่โหลดมาเจอได้ทันทีตอนซิงค์ค่าด้านล่าง
    await this.loaddataLitigationCourtStatus();

    await this.loadDocket(this.docketId); // เดิม ไม่แตะ
    await this.loadMatterShareDirectorInfo(this.form.matter_id);
    // ⭐ เพิ่มใหม่ — โหลด Document Category เดิมจากตารางลูก
    // (ต้องเรียกหลัง docketId ถูกตั้งค่าแล้วเท่านั้น)
    await this.loadDocCategories(this.docketId);

    // ⭐ เพิ่ม — ซิงค์ timelineStatus ให้ตรงกับ form.status ปัจจุบันของ
    // docket ตั้งแต่โหลดหน้าครั้งแรก (ไม่ต้องรอผู้ใช้คลิกเปลี่ยน status เอง)
    this.sendToStatus(this.form.status);

    this.pageLoading = false; // เดิม ไม่แตะ
  },
  methods: {
    onOrdinarySharesInput(index) {
      const total = this.shareholdersCurrentDisplay + this.shareholdersAddedFromTracker;

      if (total > this.shareholdersMaxNumber) {
        const row = this.trackerDetail.shareholders[index];
        const currentValue = Number(row.ordinary_shares) || 0;
        const overflow = total - this.shareholdersMaxNumber;
        const adjustedValue = Math.max(0, currentValue - overflow);

        row.ordinary_shares = adjustedValue;

        this.setupAlertDialog(
          true,
          "แจ้งเตือน",
          `จำนวนหุ้นสามัญรวม (Current + Added) เกินยอดหุ้นทั้งหมดที่มี (Number of Shares) ระบบปรับจำนวนหุ้นในแถวที่กำลังแก้ไขให้เท่ากับยอดคงเหลือให้อัตโนมัติแล้ว`,
          "text-h5 orange--text text-center",
        );
      }
    },
    async loadMatterShareDirectorInfo(matterId) {
      if (!matterId) return;
      try {
        const res = await getIncorporateMatterById(matterId);
        const matter = res.data;
        if (!matter) return;

        this.shareholdersMaxNumber = matter.number_of_shares || 0;
        this.shareholdersNumber = (matter.shareholders || []).reduce(
          (sum, sh) => sum + (Number(sh.ordinary_shares) || 0),
          0
        );
        this.existingShareholdersCount = (matter.shareholders || []).length;
        this.directorsListShow = matter.directors || [];

        this.trackerDetail.shareholders = this.trackerDetail.shareholders.map((row) => {
          const matched = (matter.shareholders || []).find(
            (ms) => (ms.full_name || "").trim().toLowerCase() === (row.full_name || "").trim().toLowerCase()
          );
          return {
            ...row,
            matter_shareholder_id: matched ? matched.id : null,
          };
        });

        // ⭐ เพิ่มใหม่ — จับคู่ trackerDetail.directors กับ matter.directors
        // ด้วยชื่อ แบบเดียวกับ shareholders เพื่อให้ backend รู้ว่าแถวไหนคือ
        // "ของเดิม ต้อง update" (มี id) กับแถวไหนคือ "ใหม่ ต้อง create" (ไม่มี id)
        this.trackerDetail.directors = this.trackerDetail.directors.map((row) => {
          const matched = (matter.directors || []).find(
            (md) => (md.full_name || "").trim().toLowerCase() === (row.full_name || "").trim().toLowerCase()
          );
          return {
            ...row,
            matter_director_id: matched ? matched.id : null,
          };
        });
      } catch (error) {
        console.error("Error loading matter shareholders/directors info:", error);
      }
    },
    async loadMatterList() {
      try {
        const res = await api.getAllIncorporateMatter();
        const list = Array.isArray(res.data) ? res.data : [];
        this.matterdatalist = list;

      } catch (error) {
        console.error("Error loading matter list:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่สามารถโหลดรายชื่อลูกค้าจาก Matter ได้",
          "text-h5 red--text text-center",
        );
      }

    },
    //quotations 
    async loaddataSalesOrder() {
      try {
        const res = await api.getQuotatinsForDocketCore(Number(localStorage.getItem(server.COMPANYID)));
        this.salesOrderList = res.data || [];

      } catch (error) {
        console.error("loaddataSalesOrder error:", error);
      }
    },
    onSelectSO(so) {
      // component ส่ง object ของ quotation ที่เลือกมาให้แล้ว (หรือ null ถ้าเคลียร์ค่า)
      if (!so) {
        this.formQutations.price = "";
        this.formQutations.customerName = "";
        this.formQutations.currency = "";
        this.quotationscheckstatus = "";
        return;
      }
      this.quotationscheckstatus = so.status;
      this.formQutations.price = Number(so.subtotal);
      this.formQutations.customerName = so.customer_name || "";
      this.formQutations.currency = so.currency || "";
    },
    async loadDataInvoice(id) {
      try {
        var dataserach = {
          module_name: 'Incorporation',
          module_id: id,
          company_id: Number(localStorage.getItem(server.COMPANYID)),
        }
        const res = await api.getQuotatinsinvoiceListCore({
          params: dataserach
        })
        this.invoiceList = res.data.data || [];
      } catch (error) {
        console.error("loadDataInvoice error:", error);
      }
    },
    async loadDataInvoiceSelect(id) {
      try {
        // หน้า Edit มี id แล้ว → ส่งไปตัด invoice ที่ผูกกับ docket นี้แล้วออก (มีโชว์ใน list ด้านล่างแล้ว)
        const res = await api.billing_expense_getInvoiceSelectList(
          Number(localStorage.getItem(server.COMPANYID)),
          "Incorporation",
          Number(id)
        );
        this.invoiceSelectList = res.data.data || [];
      } catch (error) {
        console.error("loadDataInvoiceSelect error:", error);
      }
    },
    //end quotattions
    previewInvoice(item) {
      const routeData = this.$router.resolve(
        `/edit-invoice/${item.inv_id_preview}/inv_h/edit`
      );
      window.open(routeData.href, '_blank');
    },
    // ⭐ เพิ่มใหม่ทั้งบล็อกนี้ — สำหรับ Internal Timeline (ก็อปแบบมาจาก
    // incorporate-docket-add.vue)
    closeDelete() {
      this.dialogDelete = false;
    },
    deleteItemConfirm() {
      this.tabselect = 1;
      this.dialogDelete = false;
    },
    handleRequestStatus(value) {
      this.form.status = value;
    },
    sendToStatus(value) {
      const selectedItem = this.statuslist.find(
        (item) => item.module_id === value
      );
      // ⭐ กัน error กรณี form.status เดิม (เช่นค่า hardcode เก่าจาก DB
      // ที่ไม่ตรงกับ module_id ไหนใน statuslist ที่โหลดมาจริง)
      if (selectedItem) {
        this.timelineStatus = Number(selectedItem.timeline_status_id);
      }
    },
    async loaddataLitigationCourtStatus() {
      const result = await api.getClientTimelineStatusCongFigByModule(
        "Corporate"
      );
      this.statuslist = (result.data || []).map((item) => ({
        ...item,
        module_id: item.module_id,
      }));
    },
    // ⭐ จบบล็อกเพิ่มใหม่สำหรับ Timeline

    async loadDocket(id) {
      try {
        const res = await getIncorporateDocketById(id);
        const docket = res.data;
        if (!docket) return;
        console.log(docket)
        this.client_id = docket.matter.id;
        this.client_name_show = docket.matter.client_name;
        this.matterId = docket.matter_id || null;
        this.form.matter_id = docket.matter_id || null;
        this.form.client_name = docket.client_name || "";
        this.form.entity_type =
          docket.matter?.entity_type || docket.matter_entity_type || "";
        this.form.registration_no =
          docket.matter?.registration_no || docket.matter_registration_no || "";
        this.form.inquiry_topic = docket.inquiry_topic || "";
        this.form.date_received = this.toDateInput(docket.date_received);
        this.form.date_submitted = this.toDateInput(docket.date_submitted);
        this.form.next_due_date = this.toDateInput(docket.next_due_date);

        // ⭐ Document Category ย้ายไปเก็บที่ incorporate_docket_doc_category แล้ว
        // docket.doc_category (column เดิม) เป็น '' เสมอตอนนี้ (deprecated)
        // ไม่ใช้อ่านค่าจากตรงนี้อีกต่อไป — โหลดจริงผ่าน loadDocCategories()
        // แยกต่างหาก (เรียกต่อจาก loadDocket() ใน mounted())

        // ⭐ FIX (บั๊กหลักที่พบ) — เดิมไฟล์นี้ไม่มีบรรทัดนี้เลย ทำให้
        // ไฟล์แนบที่เคยอัปโหลดไว้ไม่ขึ้นในหน้า Edit เลย
        // file_attachments เก็บเป็น comma-separated filename string
        this.existingAttachments = docket.file_attachments
          ? docket.file_attachments
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean)
          : [];

        this.form.remark = docket.remark || "";
        this.form.status = docket.status || "In Progress";
        this.formQutations.salesOrderId = docket.quotation_id;
        const so = this.salesOrderList.find(
          (item) => Number(item.quotation_id) === Number(this.formQutations.salesOrderId)
        );
        this.onSelectSO(so || null);

        // ⭐ Multi-select — โหลด Change Tracker เดิมกลับเข้าฟอร์ม จากตาราง
        // incorporate_docket_change (docket.changes มาจาก findById ที่
        // include changes + agencies ไว้แล้วฝั่ง backend) โหลดทุกรายการ
        // ที่มี ไม่ใช่แค่รายการแรกเหมือนเดิม
        if (Array.isArray(docket.changes) && docket.changes.length > 0) {
          this.form.change_tracker = docket.changes.map((c) => c.change_type);

          docket.changes.forEach((c) => {
            const detail = c.change_detail || {};

            switch (c.change_type) {
              case "shareholders": {
                const items = Array.isArray(detail.items) ? detail.items : [];
                this.trackerDetail.shareholders =
                  items.length > 0
                    ? items.map((it) => ({
                      full_name: it.full_name || "",
                      nationality: it.nationality || "",
                      ordinary_shares: it.ordinary_shares || 0,
                      preferred_shares: it.preferred_shares || 0,
                    }))
                    : this.trackerDetail.shareholders;

                // ⭐ เก็บผลรวมหุ้นสามัญของแถวที่โหลดมาจาก docket เดิม (sync เข้า Matter
                // ไปแล้วก่อนหน้านี้จากการ save ครั้งก่อน) ไว้หักออกจาก Current Shares
                // เพื่อไม่ให้นับซ้ำกับ Added (Tracker) ที่นับรวมแถวเหล่านี้ด้วยทั้งหมด
                this.syncedShareholdersAmount = items.reduce(
                  (sum, it) => sum + (Number(it.ordinary_shares) || 0),
                  0
                );
                break;
              }
              case "directors":
                this.trackerDetail.directors =
                  Array.isArray(detail.items) && detail.items.length > 0
                    ? detail.items.map((it) => ({
                      full_name: it.full_name || "",
                      nationality: it.nationality || "",
                      authorized: it.authorized || "No",
                    }))
                    : this.trackerDetail.directors;
                break;
              case "reg-capital":
                this.trackerDetail.reg_capital = detail.amount ?? "";
                break;
              case "paidup-capital":
                this.trackerDetail.paidup_capital = detail.amount ?? "";
                break;
              case "company-name":
                this.trackerDetail.company_name = detail.name || "";
                break;
              case "reg-address":
                this.trackerDetail.reg_address = detail.address || "";
                break;
              case "auditor":
                this.trackerDetail.audit_firm = detail.audit_firm || "";
                this.trackerDetail.auditor_name = detail.auditor_name || "";
                this.trackerDetail.auditor_license_no =
                  detail.auditor_license_no || "";
                break;
              case "accountant":
                this.trackerDetail.accountant_firm =
                  detail.accountant_firm || "";
                this.trackerDetail.accountant_name =
                  detail.accountant_name || "";
                break;
              case "others":
                this.trackerDetail.others_detail = detail.detail || "";
                break;
            }

            // ⭐ โหลดหน่วยงานที่เลือกไว้เดิมของ change ประเภทนี้
            this.$set(
              this.selectedAgencies,
              c.change_type,
              Array.isArray(c.agencies)
                ? c.agencies.map((a) => a.agency_name)
                : [],
            );
          });
        }
        // else: docket เก่าที่ยังไม่มีข้อมูลในตาราง incorporate_docket_change
        // จะไม่มีรายละเอียด/หน่วยงานให้กรอกต่อ — ต้องเลือกใหม่ถ้าต้องการแก้ไข
      } catch (error) {
        console.error("Error loading docket:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่สามารถโหลดข้อมูล Docket ได้",
          "text-h5 red--text text-center",
        );
      }
    },

    // ⭐ เพิ่มใหม่ — โหลด Document Category เดิมจากตารางลูก
    // (เก็บทั้ง id ไว้ใน existingDocCategories เพื่อใช้ diff ตอน save)
    // รองรับทั้ง response แบบ { success, data: [...] } และแบบ array ตรงๆ
    // เผื่อ controller ยังไม่ได้เช็คให้แน่ชัด — ถ้าพังค่อยไปแก้ backend ทีหลัง
    async loadDocCategories(docketId) {
      try {
        const res = await getIncorporateDocketDocCategoryByDocketId(docketId);
        const list = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
            ? res.data.data
            : [];
        this.existingDocCategories = list.map((item) => ({
          id: item.id,
          doc_category: item.doc_category,
        }));
        this.form.doc_category = this.existingDocCategories.map(
          (item) => item.doc_category
        );
      } catch (error) {
        console.error("Error loading doc categories:", error);
        // ไม่ block การโหลดหน้าเพียงเพราะโหลดส่วนนี้ไม่สำเร็จ
      }
    },

    toDateInput(dateStr) {
      if (!dateStr) return "";
      try {
        return new Date(dateStr).toISOString().slice(0, 10);
      } catch {
        return "";
      }
    },

    // ⭐ สร้าง URL ไปยังไฟล์จริงบน Production Storage
    // path จริง: {PRODUCTION_STORAGE_URL}/incorporatedocket/{docketId}/{filename}
    attachmentUrl(filename) {
      return `${this.fileIncorporateUrl}/${this.docketId}/${filename}`;
    },

    // ⭐ เลือกไอคอนตามนามสกุลไฟล์ ให้พอแยกประเภทได้ในรายการ
    fileIcon(filename) {
      const ext = (filename.split(".").pop() || "").toLowerCase();
      if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext))
        return "mdi-file-image-outline";
      if (ext === "pdf") return "mdi-file-pdf-box";
      if (["doc", "docx"].includes(ext)) return "mdi-file-word-outline";
      return "mdi-file-document-outline";
    },

    // ⭐ เปิด dialog ยืนยันก่อนลบจริง (ป้องกันกดลบพลาด เพราะลบแล้วกู้คืนไม่ได้)
    confirmRemoveAttachment(filename) {
      this.fileToDelete = filename;
      this.dialogConfirmDelete = true;
    },

    // ⭐ ลบไฟล์แนบ 1 ไฟล์จริง — เรียก backend ที่จะลบทั้ง local file,
    // DB column file_attachments, และ sync ลบที่ Production/Backup Storage
    // ให้ครบในคำเดียว (ดู incorporate_docket.controller.js removeAttachment)
    async removeExistingAttachment(filename) {
      this.removingFile = filename;
      this.dialogConfirmDelete = false;
      try {
        await removeIncorporateDocketAttachment(this.docketId, filename);
        this.existingAttachments = this.existingAttachments.filter(
          (f) => f !== filename,
        );
        this.setupAlertDialog(
          true,
          "Success",
          "ลบไฟล์เรียบร้อยแล้ว",
          "text-h5 green--text text-center",
        );
      } catch (error) {
        console.error("Error removing attachment:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่สามารถลบไฟล์ได้ กรุณาลองใหม่",
          "text-h5 red--text text-center",
        );
      } finally {
        this.removingFile = null;
        this.fileToDelete = null;
      }
    },

    // ⭐ Multi-select — คลิกเพื่อเพิ่ม/เอาออกจากรายการที่เลือก
    selectDocCategory(cat) {
      const idx = this.form.doc_category.indexOf(cat);
      if (idx >= 0) {
        this.form.doc_category.splice(idx, 1);
      } else {
        this.form.doc_category.push(cat);
      }
    },

    // ⭐ Multi-select — คลิกเพื่อเพิ่ม/เอาออกจากรายการที่เลือก
    // ตอนเอาออก ต้องล้าง selectedAgencies ของ key นั้นด้วย (ตัวอื่นที่เลือกอยู่ไม่กระทบ)
    selectTracker(key) {
      const idx = this.form.change_tracker.indexOf(key);
      if (idx >= 0) {
        this.form.change_tracker.splice(idx, 1);
        this.$delete(this.selectedAgencies, key);
      } else {
        this.form.change_tracker.push(key);
        this.$set(this.selectedAgencies, key, []);
      }
    },

    isAgencySelected(trackerKey, agency) {
      return (this.selectedAgencies[trackerKey] || []).includes(agency);
    },

    toggleAgency(trackerKey, agency) {
      if (!this.selectedAgencies[trackerKey]) {
        this.$set(this.selectedAgencies, trackerKey, []);
      }
      const list = this.selectedAgencies[trackerKey];
      const idx = list.indexOf(agency);
      if (idx >= 0) {
        list.splice(idx, 1);
      } else {
        list.push(agency);
      }
    },

    addShareholderRow() {
      this.trackerDetail.shareholders.push({
        full_name: "",
        nationality: "",
        ordinary_shares: 0,
        preferred_shares: 0,
      });
    },
    addDirectorRow() {
      this.trackerDetail.directors.push({
        full_name: "",
        nationality: "",
        authorized: "No",
      });
    },

    getDocketStatusColor(status) {
      const map = {
        "In Progress": "blue lighten-4",
        Complete: "green lighten-4",
        "Request Payment": "pink lighten-4",
        Cancelled: "red lighten-4",
      };
      return map[status] || "grey lighten-3";
    },
    getDocketStatusTextColor(status) {
      const map = {
        "In Progress": "blue darken-2",
        Complete: "green darken-2",
        "Request Payment": "pink darken-2",
        Cancelled: "red darken-2",
      };
      return map[status] || "grey darken-1";
    },

    validateForm() {
      if (!this.form.inquiry_topic || !this.form.inquiry_topic.trim()) {
        this.setupAlertDialog(
          true,
          "Check information",
          "กรุณากรอก Inquiry Topic",
          "text-h5 red--text text-center",
        );
        return false;
      }
      if (!this.form.date_received) {
        this.setupAlertDialog(
          true,
          "Check information",
          "กรุณากรอก Date Received",
          "text-h5 red--text text-center",
        );
        return false;
      }
      // ⭐ เพิ่มใหม่ — บังคับกรอก Next Due Date เพราะหน้า Incorporate
      // Overview ใช้ field นี้เป็นตัวหลักในการคำนวณ Overdue / Due Soon
      // และรายการ "Docket ที่ใกล้ครบกำหนด" ทั้งหมด (ดู upcomingDockets,
      // isOverdue ใน IncorporateOverview.vue) ถ้าเว้นว่างไว้ docket นี้
      // จะไม่ถูกนับรวมในหน้า Overview เลยโดยไม่มีการแจ้งเตือนใด ๆ
      if (!this.form.next_due_date) {
        this.setupAlertDialog(
          true,
          "Check information",
          "กรุณากรอก Next Due Date | วันครบกำหนดถัดไป (ใช้คำนวณสถานะ Overdue/Due Soon ในหน้า Overview)",
          "text-h5 red--text text-center",
        );
        return false;
      }
      for (const key of this.form.change_tracker) {
        const agencies = this.selectedAgencies[key] || [];
        if (agencies.length === 0) {
          const label =
            this.trackerOptions.find((t) => t.key === key)?.label || key;
          this.setupAlertDialog(
            true,
            "Check information",
            `กรุณาเลือกหน่วยงานที่ต้องดำเนินการสำหรับ "${label}" อย่างน้อย 1 หน่วยงาน`,
            "text-h5 red--text text-center",
          );
          return false;
        }
      }
      return true;
    },

    buildFormData() {
      const fd = new FormData();
      const company_id = localStorage.getItem(server.COMPANYID);
      const user_id = localStorage.getItem(server.USER_ID);

      if (this.form.matter_id) fd.append("matter_id", this.form.matter_id);
      fd.append("client_name", this.form.client_name);
      fd.append("inquiry_topic", this.form.inquiry_topic);
      // ⭐ เหมือนหน้า Add — column เดิมเก็บเป็น '' เสมอ ข้อมูลจริงอยู่ตารางลูก
      // (incorporate_docket_doc_category / incorporate_docket_change)
      fd.append("doc_category", "");
      fd.append("change_tracker", "");

      // ⭐ แก้ไข (รอบ 2 — หลังตรวจ repository จริงแล้ว) — date_received และ
      // next_due_date ผ่านการบังคับกรอกจาก validateForm() มาแล้วเสมอ จึงส่ง
      // ค่าตรง ๆ ได้เลย ส่วน date_submitted (ไม่บังคับกรอก) ส่งกลับไปแบบเดิม
      // เสมอ (value || "") แทนที่จะ "ไม่ append field เลยเมื่อว่าง" ตามที่เคย
      // แก้ไว้รอบแรก เพราะพบว่า incorporate_docket.repository.js ฝั่ง
      // exports.update() ใช้ Sequelize Model.update() ซึ่งจะ "ข้าม field ที่
      // เป็น undefined ไปเฉย ๆ ไม่แตะค่าเดิมใน DB เลย" (ยืนยันจาก pattern
      // invoice_id ในไฟล์เดียวกัน: `data.invoice_id !== undefined ? ... :
      // undefined` ที่ตั้งใจอาศัยพฤติกรรมนี้) — ถ้าไม่ append field ตอนผู้ใช้
      // ลบ date_submitted ที่เคยกรอกไว้จนว่างเพื่อ "ล้างค่า" (เคสสำคัญของหน้า
      // Edit นี้โดยเฉพาะ) DB จะไม่ถูกล้างให้เลย จึงย้ายหน้าที่ sanitize
      // "" → null ไปทำที่ repository แทน (ดู sanitizeDateOnly() ใน
      // incorporate_docket.repository.js) แล้วให้ frontend ส่งค่าตรง ๆ
      // เสมอแบบง่าย ๆ พอ — วิธีนี้ทำให้ "ล้างค่า date_submitted" ทำงานถูกต้อง
      fd.append("date_received", this.form.date_received);
      fd.append("next_due_date", this.form.next_due_date);
      fd.append("date_submitted", this.form.date_submitted || "");

      fd.append("status", this.form.status);
      fd.append("remark", this.form.remark || "");
      fd.append("company_id", company_id);
      fd.append("user_update", user_id);
      fd.append("quotation_id", Number(this.formQutations.salesOrderId));

      // ⭐ เฉพาะไฟล์ใหม่ (form.attachments) เท่านั้นที่ส่งเป็น multipart
      // ไฟล์เดิม (existingAttachments) ไม่ต้องส่งซ้ำ — backend ฝั่ง update
      // จะ append ไฟล์ใหม่ต่อจาก file_attachments เดิมที่มีอยู่ในแล้วอัตโนมัติ
      // (ดู incorporate_docket.controller.js exports.update)
      if (this.form.attachments && this.form.attachments.length > 0) {
        this.form.attachments.forEach((file) => fd.append("file", file));
      }

      return fd;
    },

    buildChangesPayload() {
      return this.form.change_tracker.map((key) => {
        let change_detail = {};

        switch (key) {
          case "shareholders":
            change_detail = {
              items: this.trackerDetail.shareholders
                .filter((s) => s.full_name && s.full_name.trim() !== "")
                .map((s, index) => ({
                  full_name: s.full_name,
                  nationality: s.nationality,
                  ordinary_shares: Number(s.ordinary_shares) || 0,
                  preferred_shares: Number(s.preferred_shares) || 0,
                  sort_order: this.existingShareholdersCount + index,
                  matter_shareholder_id: s.matter_shareholder_id || null,   // ⭐ เพิ่มใหม่
                })),
            };
            break;
          case "directors":
            change_detail = {
              items: this.trackerDetail.directors
                .filter((d) => d.full_name && d.full_name.trim() !== "")
                .map((d) => ({
                  full_name: d.full_name,
                  nationality: d.nationality,
                  authorized: d.authorized,
                  matter_director_id: d.matter_director_id || null,   // ⭐ เพิ่มใหม่
                })),
            };
            break;
          case "reg-capital":
            change_detail = {
              amount: Number(this.trackerDetail.reg_capital) || 0,
            };
            break;
          case "paidup-capital":
            change_detail = {
              amount: Number(this.trackerDetail.paidup_capital) || 0,
            };
            break;
          case "company-name":
            change_detail = { name: this.trackerDetail.company_name || "" };
            break;
          case "reg-address":
            change_detail = { address: this.trackerDetail.reg_address || "" };
            break;
          case "auditor":
            change_detail = {
              audit_firm: this.trackerDetail.audit_firm || "",
              auditor_name: this.trackerDetail.auditor_name || "",
              auditor_license_no: this.trackerDetail.auditor_license_no || "",
            };
            break;
          case "accountant":
            change_detail = {
              accountant_firm: this.trackerDetail.accountant_firm || "",
              accountant_name: this.trackerDetail.accountant_name || "",
            };
            break;
          case "others":
            change_detail = { detail: this.trackerDetail.others_detail || "" };
            break;
        }

        return {
          change_type: key,
          change_detail,
          agencies: this.selectedAgencies[key] || [],
        };
      });
    },

    // ⭐ เพิ่มใหม่ — sync Document Category ด้วยการ diff เพราะไม่มี
    // replace-all endpoint (ต่างจาก Change Tracker) ต้องเทียบเองว่าอันไหน
    // ต้อง create ใหม่ อันไหนต้อง delete ออก โดยเทียบกับ existingDocCategories
    // ที่โหลดมาตอน loadDocCategories()
    async syncDocCategories(docketId) {
      const existingLabels = this.existingDocCategories.map(
        (c) => c.doc_category
      );
      const currentLabels = this.form.doc_category;

      // อันที่ถูกเอาออก (มีใน existing แต่ไม่มีใน current) → ลบ
      const toDelete = this.existingDocCategories.filter(
        (c) => !currentLabels.includes(c.doc_category)
      );
      // อันที่เพิ่มใหม่ (มีใน current แต่ไม่มีใน existing) → สร้าง
      const toAdd = currentLabels.filter(
        (cat) => !existingLabels.includes(cat)
      );

      const user_id = Number(localStorage.getItem(server.USER_ID));

      for (const item of toDelete) {
        await deleteIncorporateDocketDocCategory(item.id);
      }
      for (const cat of toAdd) {
        await createIncorporateDocketDocCategory({
          docket_id: docketId,
          doc_category: cat,
          user_create: user_id,
        });
      }
    },

    // ⭐ บันทึกแก้ไขจริง — ทำขั้นตอนต่อกัน:
    // 1) แก้ไข docket หลัก (multipart/form-data — อัปโหลดไฟล์ใหม่ถ้ามี) — เดิม
    // 2) ⭐ เพิ่ม — sync Document Category (diff add/delete)
    // 3) ⭐ เพิ่ม — สร้าง timeline record ใหม่ + regenerate PDF client
    //    progress ผูกกับ docketId เดิม (มีอยู่แล้วตั้งแต่เปิดหน้า Edit
    //    ต่างจาก add.vue ที่ต้องรอสร้าง docket ก่อนถึงจะมี id)
    // 4) replace-all Change Tracker ทั้งชุด — เดิม

    async updateDocket(mode) {
      if (!this.validateForm()) return; // เดิม ไม่แตะ
      // ✅ ตรวจว่าลูกค้าใน Quotation ตรงกับลูกค้าของ Matter ที่ผูกกับ Docket นี้
      if (this.formQutations.salesOrderId) {
        const selectedSO = this.salesOrderList.find(
          (item) => Number(item.quotation_id) === Number(this.formQutations.salesOrderId)
        );

        if (!selectedSO) {
          this.setupAlertDialog(
            true,
            "Check information",
            "ไม่พบใบเสนอราคาที่เลือก กรุณาเลือกใหม่อีกครั้ง",
            "text-h5 red--text text-center"
          );
          return;
        }

        const matterData = this.matterdatalist.find(
          (item) => Number(item.id) === Number(this.form.matter_id)
        );

        if (!matterData) {
          this.setupAlertDialog(
            true,
            "Check information",
            "ไม่พบข้อมูลลูกค้า (Matter) กรุณาตรวจสอบข้อมูลอีกครั้ง",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (Number(selectedSO.client_id) !== Number(matterData.client_id)) {
          this.setupAlertDialog(
            true,
            "ข้อมูลลูกค้าไม่ตรงกัน",
            `ใบเสนอราคา ${selectedSO.doc_no} เป็นของลูกค้า "${selectedSO.customer_name || "-"}" ซึ่งไม่ตรงกับลูกค้าที่ผูกกับ Docket นี้ กรุณาเลือกใหม่ให้ถูกต้อง`,
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      if (this.timelineStatus == 0 || this.status_note.trim() == "") {
        this.dialogDelete = true;
        return;
      }

      // ⭐ เพิ่ม — บังคับให้กรอก Internal Timeline ก่อน save เสมอ
      // เหมือนกับ incorporate-docket-add.vue
      if (this.timelineStatus == 0 || this.status_note.trim() == "") {
        this.dialogDelete = true;
        return;
      }

      this.loadingSave = true; // เดิม ไม่แตะ
      this.$showLoader(); // เดิม ไม่แตะ

      try {
        const fd = this.buildFormData(); // เดิม ไม่แตะ
        await updateIncorporateDocket(this.docketId, fd); // เดิม ไม่แตะ

        // ⭐ เพิ่มใหม่ — sync Document Category (diff add/delete) หลัง docket
        // หลักอัปเดตสำเร็จ ถ้า fail แจ้ง error เฉพาะจุดแล้ว return ทันที
        // เหมือน pattern เดียวกับหน้า Add (ไม่ throw ไปให้ catch ใหญ่ตอนท้าย
        // จับเงียบ ๆ เพราะข้อมูลนี้ผู้ใช้ตั้งใจเลือกเอง ต้องรู้ทันทีถ้าพัง)
        try {
          await this.syncDocCategories(this.docketId);
        } catch (docCategoryError) {
          console.error("Error syncing doc category:", docCategoryError);
          this.$hideLoader();
          this.loadingSave = false;
          this.setupAlertDialog(
            true,
            "Error",
            "บันทึก Docket สำเร็จ แต่เกิดข้อผิดพลาดในการอัปเดต Document Category กรุณาลองใหม่อีกครั้ง",
            "text-h5 red--text text-center",
          );
          return;
        }

        try {
          if (this.quotationscheckstatus == "Submitted") {

            var dataupdateStatus = {
              status: "InProgress"
            }
            await api.updateQuotationsCore(Number(this.formQutations.salesOrderId), dataupdateStatus)
          }
        } catch (quotationsError) {
          console.log(quotationsError)
        }
        // ⭐ เพิ่ม — บันทึก timeline history record ใหม่ ผูกกับ docketId
        // เดิมที่มีอยู่แล้ว (ไม่ต้องมี main_id ชั่วคราวแบบ add.vue)
        const dataadd_timeline = {
          timeline_status_id: Number(this.timelineStatus),
          case_id: Number(this.docketId),
          module_name: "Corporate",
          case_woker: Number(localStorage.getItem(server.USER_ID)),
          status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
          status_note: this.status_note.trim(),
          visibility: this.visible_check,
        };
        await api.creategetClientTimelineHistory(dataadd_timeline);

        // ⭐ เพิ่ม — regenerate PDF client progress เหมือน add.vue
        // ไม่ throw ต่อถ้า fail (ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึก
        // docket / change tracker ที่เหลือ)
        try {
          const caseDetailResult = await api.getgetTimelineDataDetail({
            params: {
              module_name: this.module_name,
              case_id: Number(this.docketId),
            },
          });
          const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

          const visibilityResult =
            await api.getgetClientTimelineHistoryShowVisibility({
              params: {
                module_name: this.module_name,
                case_id: Number(this.docketId),
              },
            });
          const timelineData = visibilityResult.data || [];

          caseInfo.status = timelineData[0]?.status || "";
          caseInfo.lastUpdated = timelineData[0]?.status_time || "";

          const latestUpdate = {
            message: timelineData[0]?.status_note || "",
            date: timelineData[0]?.status_time || "",
          };

          await PDFCaseProgress.createToPDF(
            {
              caseInfo,
              latestUpdate,
              timelineData,
              caseId: Number(this.docketId),
              moduleName: this.module_name,
            },
            { open: false }
          );
        } catch (pdfError) {
          console.error("PDF generation/upload failed:", pdfError);
          // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก
        }
        //add payment invoice
        if (this.formQutations.invoiceId) {
          try {
            // อัปเดตสถานะ Quotation: InProgress → Invoiced (ถ้ามี Quotation)
            if (Number(this.formQutations.salesOrderId) > 0) {
              try {
                const resQuotations = await api.billing_expense_getAllQuotationsByID(Number(this.formQutations.salesOrderId));
                if (resQuotations.data.status == "InProgress") {
                  var dataupdateStatusInvoiced = {
                    status: "Invoiced"
                  }
                  await api.updateQuotationsCore(Number(this.formQutations.salesOrderId), dataupdateStatusInvoiced)
                }
              } catch (error) {
                console.log("loadQuotations Error")
              }
            }

            var dataadd_payment_invoice = {
              inv_id: Number(this.formQutations.invoiceId),
              module_name: "Incorporation",
              module_id: Number(this.docketId),
              company_id: Number(localStorage.getItem(server.COMPANYID)),
              user_create: Number(localStorage.getItem(server.USER_ID)),
              user_update: Number(localStorage.getItem(server.USER_ID)),
              department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
              quotation_id: Number(this.formQutations.salesOrderId) || null,
            }
            await api.billing_expense_create_payment_invoice(dataadd_payment_invoice)
          } catch (paymentInvoiceError) {
            console.error("Link payment invoice failed:", paymentInvoiceError);
            // ไม่ throw ต่อ — ไม่ให้กระทบการบันทึก Change Tracker
          }
        }
        //end add payment invoice
        // ↓↓↓ เดิม ไม่แตะ ↓↓↓
        const user_id = localStorage.getItem(server.USER_ID);
        const changes = this.buildChangesPayload();
        await replaceIncorporateDocketChangeAll(this.docketId, {
          changes,
          user_id,
          matter_id: this.form.matter_id,
        });

        this.$hideLoader();
        this.loadingSave = false;
        if (mode == "Save") {
          this.setupAlertDialogPush(
            true,
            "Success",
            "บันทึกข้อมูลสำเร็จ",
            "text-h5 green--text text-center",
            `/incorporate-docket-view/${this.docketId}`,
          );
        } else {
          var mainid = this.docketId;
          var matterid = Number(this.form.matter_id);

          var customer_list = this.matterdatalist.find(
            item => Number(item.id) === matterid
          )
          var customer_name_master_show = this.client_name_show
          var clientid = customer_list.client_id;

          var dataPush = {
            customer_name_master: customer_name_master_show,
            module_id: 0,
            quotation_id: Number(this.formQutations.salesOrderId),
          }

          dataPush.module_id = Number(mainid);

          this.$router.push({
            path: `/new-free-invoice/0/invoice/D/${clientid}/Incorporation`,
            query: dataPush,
          });
        }
      } catch (error) {
        this.$hideLoader();
        this.loadingSave = false;
        console.error("Error updating docket:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "เกิดข้อผิดพลาดในการบันทึก",
          "text-h5 red--text text-center",
        );
      }
    },

    // ⭐ FIX: คอมโพเนนต์ SuccessDialog.vue ผูก v-model กับ
    // $store.state.global_dialog โดยตรง (ไม่ได้ใช้ "status" prop ที่ส่งเข้าไป
    // เลยแม้แต่จุดเดียว) ดังนั้นถ้าตั้งแค่ this.dialogAdd = status เฉย ๆ
    // popup จะไม่เด้งขึ้นมาเลย — ต้อง sync เข้า store ทุกครั้งที่เรียกใช้
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.$store.state.global_dialog = status;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAddPush = status;
      this.text_color = text_color;
      this.link = link;
      this.$store.state.global_push_dialog = status;
    },
  },
};
